import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {
  RestaurantsGroup
} from 'PMT/entities/restaurantsGroup';

// -- views

export default class RestaurantsGroupHierarchyView extends Component {

  static defaultProps = {
    level: 0,

    selectedRestaurantsGroup: null,

    readOnly: false
  };

  static propTypes = {
    restaurantsGroup: PropTypes.instanceOf(RestaurantsGroup).isRequired,

    selectedRestaurantsGroup: PropTypes.instanceOf(RestaurantsGroup),

    level: PropTypes.number,

    readOnly: PropTypes.bool,

    onSelect: PropTypes.func
  }

  //
  // Renderers
  //

  renderSublist() {
    return this.props.restaurantsGroup.children.map((restaurantsGroupChild: RestaurantsGroup) => {
      return (
        <RestaurantsGroupHierarchyView
          key={restaurantsGroupChild.id}
          level={this.props.level + 1}
          restaurantsGroup={restaurantsGroupChild}
          selectedRestaurantsGroup={this.props.selectedRestaurantsGroup}
          readOnly={this.props.readOnly}
          onSelect={this.props.onSelect}
        />
      );
    });
  }

  render() {
    const isCurrent = !_.isNull(this.props.selectedRestaurantsGroup) && this.props.selectedRestaurantsGroup.id === this.props.restaurantsGroup.id;

    const mainClassName = classNames('restaurants_group_hierarchy', {
      current: isCurrent
    });

    const groupNameClassName = classNames('group_name', {
      current: isCurrent
    });

    return (
      <div className={mainClassName}>
        <h3
          className={groupNameClassName}
          onClick={() => this.props.onSelect(this.props.restaurantsGroup) }
        >
          {this.props.restaurantsGroup.name}
        </h3>

        <div>
          {this.renderSublist()}
        </div>
      </div>
    );
  }
}
